// src/data/blogsData.js

export const allBlogsData = [
  {
    id: 'BLG-001',
    title: 'Top 10 Handmade Products for 2024',
    description: 'Discover the most trending handmade products that every craft lover should know about.',
    image: 'https://i.pinimg.com/1200x/7b/e5/01/7be501840130cc7618a076bf27867320.jpg',
    category: 'Trending',
    author: 'Admin',
    authorImage: 'https://via.placeholder.com/50',
    date: '15 Jan 2024',
    readTime: '5 min read',
    slug: 'top-10-handmade-products-2024',
    content: [
      { 
        type: 'paragraph', 
        text: 'Handmade products have gained immense popularity in 2024. From pottery to jewelry, explore the best crafts of this year that are making waves in the market.' 
      },
      { 
        type: 'heading', 
        text: '1. Handwoven Textiles' 
      },
      { 
        type: 'paragraph', 
        text: 'Traditional handwoven textiles are making a strong comeback. These unique pieces showcase the skill and dedication of artisans.' 
      },
      { 
        type: 'heading', 
        text: '2. Ceramic Pottery' 
      },
      { 
        type: 'paragraph', 
        text: 'Hand-thrown ceramic pieces are not just functional but also works of art. Each piece tells a unique story.' 
      },
      { 
        type: 'heading', 
        text: '3. Artisan Jewelry' 
      },
      { 
        type: 'paragraph', 
        text: 'Handcrafted jewelry pieces made with traditional techniques are in high demand among fashion enthusiasts.' 
      },
      { 
        type: 'paragraph', 
        text: 'These products represent the finest craftsmanship and dedication to traditional arts.' 
      }
    ]
  },
  {
    id: 'BLG-004',
    title: 'CraftHive par handmade products kyun special hain',
    description: 'CraftHive pe milne wale handmade products ki unique qualities aur artisans ki dedication ke baare mein jaaniye.',
    image: 'https://i.pinimg.com/1200x/06/4f/73/064f73fb4d6c9da02d99544ea294eb4a.jpg',
    category: 'CraftHive',
    author: 'Admin',
    authorImage: 'https://via.placeholder.com/50',
    date: '13 Jan 2024',
    readTime: '4 min read',
    slug: 'crafthive-handmade-products-special',
    content: [
      { 
        type: 'paragraph', 
        text: 'CraftHive par aapko milte hain woh handmade products jo na sirf unique hain balki har ek product ek kahani bayaan karta hai. Har product ke peeche ek skilled artisan ki mehnat aur creativity chupi hui hai.' 
      },
      { 
        type: 'heading', 
        text: 'Har Product Unique Hai' 
      },
      { 
        type: 'paragraph', 
        text: 'Machine-made products ke mukable, handmade items mein har piece thoda alag hota hai. Yeh uniqueness hi unhe special banati hai. Jab aap CraftHive se kuch khareedtey hain, toh aapko pata hai ke woh ek-of-a-kind hai.' 
      },
      { 
        type: 'paragraph', 
        text: 'Har artisan apne products mein apni unique style aur technique use karta hai, jo har piece ko alag banata hai.' 
      },
      { 
        type: 'heading', 
        text: 'Quality aur Craftsmanship' 
      },
      { 
        type: 'paragraph', 
        text: 'Hamare artisans apne kaam mein perfectionism maintain kartey hain. Har stitch, har color, har design ko detail ke saath craft kiya jata hai. Yeh quality mass-produced items mein nahi milti.' 
      },
      { 
        type: 'heading', 
        text: 'Local Artisans ko Support' 
      },
      { 
        type: 'paragraph', 
        text: 'Jab aap CraftHive se shopping karte hain, toh aap directly local artisans aur small businesses ko support kar rahe hain. Aapki har purchase se ek family ko sahara milta hai.' 
      },
      { 
        type: 'heading', 
        text: 'Eco-Friendly aur Sustainable' 
      },
      { 
        type: 'paragraph', 
        text: 'Handmade products generally sustainable materials se bante hain aur environment ke liye behtar hote hain. Mass production ke mukable kam pollution aur wastage hota hai.' 
      }
    ]
  },
  {
    id: 'BLG-005',
    title: 'CraftHive ke Top 5 Best-Selling Handmade Products',
    description: 'Hamare platform par sabse zyada bikne wale 5 handmade products aur unki khasiyat.',
    image: 'https://i.pinimg.com/736x/c6/c3/fa/c6c3fa8a44c17f2c6ad4942114f17fcb.jpg',
    category: 'CraftHive',
    author: 'Admin',
    authorImage: 'https://via.placeholder.com/50',
    date: '12 Jan 2024',
    readTime: '6 min read',
    slug: 'crafthive-top-5-best-selling-products',
    content: [
      { 
        type: 'paragraph', 
        text: 'Hamare platform par kuch products customers ko especially pasand aa rahe hain. Chaliye dekhte hain top 5 best-selling handmade products.' 
      },
      { 
        type: 'heading', 
        text: '1. Hand-painted Pottery' 
      },
      { 
        type: 'paragraph', 
        text: 'Traditional pottery items jo hand-painted hain, customers ki pehli pasand ban chuki hain.' 
      },
      { 
        type: 'heading', 
        text: '2. Embroidered Home Textiles' 
      },
      { 
        type: 'paragraph', 
        text: 'Beautifully embroidered cushion covers aur table runners high demand mein hain.' 
      },
      { 
        type: 'heading', 
        text: '3. Artisan Jewelry Collection' 
      },
      { 
        type: 'paragraph', 
        text: 'Handcrafted jewelry pieces jo traditional designs ke saath modern touch rakhti hain.' 
      },
      { 
        type: 'heading', 
        text: '4. Wooden Handicrafts' 
      },
      { 
        type: 'paragraph', 
        text: 'Carved wooden decorative items jo har ghar ko unique look deti hain.' 
      },
      { 
        type: 'heading', 
        text: '5. Handwoven Bags' 
      },
      { 
        type: 'paragraph', 
        text: 'Eco-friendly aur stylish handwoven bags jo daily use ke liye perfect hain.' 
      }
    ]
  },
  {
    id: 'BLG-002',
    title: 'How to Start Your Online Shop',
    description: 'A complete guide to starting your handmade business online with practical tips.',
    image: 'https://i.pinimg.com/736x/e5/17/d4/e517d4cc3896dc5a7e5f4894c25401f5.jpg',
    category: 'Business', 
    author: 'Admin',
    authorImage: 'https://via.placeholder.com/50',
    date: '11 Jan 2024',
    readTime: '8 min read',
    slug: 'how-to-start-online-shop',
    content: [
      { 
        type: 'paragraph', 
        text: 'Starting an online shop for your handmade products can be exciting and profitable. Here\'s a comprehensive guide to help you begin.' 
      },
      { 
        type: 'heading', 
        text: 'Choose Your Platform' 
      },
      { 
        type: 'paragraph', 
        text: 'Select the right platform that suits your needs. CraftHive provides all the tools you need to start selling.' 
      },
      { 
        type: 'heading', 
        text: 'Create Quality Product Photos' 
      },
      { 
        type: 'paragraph', 
        text: 'Good photography is essential for online sales. Show your products from multiple angles with proper lighting.' 
      },
      { 
        type: 'heading', 
        text: 'Write Compelling Descriptions' 
      },
      { 
        type: 'paragraph', 
        text: 'Describe your products in detail. Tell the story behind each piece and highlight what makes it special.' 
      },
      { 
        type: 'heading', 
        text: 'Price Your Products Right' 
      },
      { 
        type: 'paragraph', 
        text: 'Consider material costs, time, and market rates when pricing your handmade items.' 
      }
    ]
  },
  {
    id: 'BLG-003',
    title: 'Crafting Tips for Beginners',
    description: 'Essential tips and tricks for new crafters to improve their skills.',
    image: 'https://i.pinimg.com/736x/02/fa/e8/02fae808293071d73811ec33fc9d79a3.jpg',
    category: 'Tips',
    author: 'Admin',
    authorImage: 'https://via.placeholder.com/50',
    date: '09 Jan 2024',
    readTime: '7 min read',
    slug: 'crafting-tips-beginners',
    content: [
      { 
        type: 'paragraph', 
        text: 'Starting your crafting journey can be overwhelming. Here are essential tips to help beginners improve their skills.' 
      },
      { 
        type: 'heading', 
        text: 'Start with Simple Projects' 
      },
      { 
        type: 'paragraph', 
        text: 'Don\'t jump into complex projects immediately. Build your skills gradually with simple, manageable projects.' 
      },
      { 
        type: 'heading', 
        text: 'Invest in Quality Tools' 
      },
      { 
        type: 'paragraph', 
        text: 'Good quality tools make a significant difference in the outcome of your work.' 
      },
      { 
        type: 'heading', 
        text: 'Practice Regularly' 
      },
      { 
        type: 'paragraph', 
        text: 'Consistency is key. Dedicate time each week to practice and improve your skills.' 
      },
      { 
        type: 'heading', 
        text: 'Join Crafting Communities' 
      },
      { 
        type: 'paragraph', 
        text: 'Connect with other crafters to learn, share ideas, and get inspired.' 
      }
    ]
  }
];